import _Accordion from "@material-ui/core/esm/Accordion";
import _AccordionDetails from "@material-ui/core/esm/AccordionDetails";
import _AccordionSummary from "@material-ui/core/esm/AccordionSummary";
import React, { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import AddIcon from '@material-ui/icons/Add';
import MinimizeIcon from '@material-ui/icons/Minimize';
import { FilterType } from 'swag-client-common/interfaces/filters';
import { CheckboxSection } from './components/checkbox-section';
import ColorSection from './components/color-section';
import PriceRange from './components/price-range';
import { BoxAndInventory } from './components/box-and-inventory';
import { InfoTooltip } from './components/info-tooltip';
import { lowercaseConjunction } from './filter-item.util';
import classes from './filter-item.scss';
import { CheckboxInputType } from './components/checkbox-section/checkbox';
import { ShippingFilterComponent } from './components/shipping';
const DEFAULT_ITEMS_COUNT_TO_SHOW = 3;
export const FilterItem = ({
  type,
  data,
  selectedFilter,
  disabledFilter = {},
  filterItem: {
    filterId,
    filterName,
    filterData
  },
  isAttributes = false,
  className,
  color = '',
  maxItemsCountToShow = DEFAULT_ITEMS_COUNT_TO_SHOW,
  isAvailableSuperSpeed,
  onChangeCheckboxFilter,
  onChangeRadioFilter,
  onChangePriceRange,
  onChangeBox,
  onInventoryChange,
  onSuperSpeedChange,
  onInternationalShippingChange
}) => {
  const [isItemOpened, setIsItemOpened] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(true);
  useEffect(() => {
    if (!isCollapsed) {
      setIsCollapsed(true);
    }
  }, [data.length]);
  const handlePanelClick = () => {
    !isItemOpened && setIsItemOpened(true);
  };
  const handleMinimizeIconClick = () => {
    setIsItemOpened(false);
  };
  const toggleCollapse = () => setIsCollapsed(prev => !prev);
  const isCollapsible = useMemo(() => {
    const allowedTypes = [FilterType.CHECKBOX, FilterType.RADIOBUTTON];
    return Boolean(allowedTypes.includes(type) && data.length > maxItemsCountToShow);
  }, [type, maxItemsCountToShow, data.length]);
  const dataToRender = useMemo(() => {
    if (!isCollapsible || !isCollapsed) {
      return data;
    }
    return data.slice(0, maxItemsCountToShow);
  }, [data, maxItemsCountToShow, isCollapsed, isCollapsible]);
  const selectTypeOfFilterItem = () => {
    switch (type) {
      case FilterType.CHECKBOX:
        return /*#__PURE__*/React.createElement(CheckboxSection, {
          filterData: dataToRender,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          dataInput: filterName,
          color: color,
          type: CheckboxInputType.CHECKBOX,
          onClickCheckbox: (filterPropertyValue, categoriesIdToRemove) => onChangeCheckboxFilter(filterId, filterPropertyValue, isAttributes, categoriesIdToRemove)
        });
      case FilterType.RADIOBUTTON:
        return /*#__PURE__*/React.createElement(CheckboxSection, {
          filterData: dataToRender,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          type: CheckboxInputType.RADIOBUTTON,
          dataInput: filterName,
          onClickCheckbox: filterPropertyValue => onChangeRadioFilter(filterId, filterPropertyValue)
        });
      case FilterType.COLOR_CIRCLES:
        return /*#__PURE__*/React.createElement(ColorSection, {
          filterData: dataToRender,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          onClickCheckbox: filterPropertyValue => onChangeCheckboxFilter(filterId, filterPropertyValue, false)
        });
      case FilterType.PRICE_RANGE:
        return /*#__PURE__*/React.createElement(PriceRange, {
          filterData: dataToRender,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          onChange: filterPropertyValue => onChangePriceRange(filterId, filterPropertyValue)
        });
      case FilterType.BOX_AND_INVENTORY:
        return /*#__PURE__*/React.createElement(BoxAndInventory, {
          filterData: dataToRender,
          isDisabled: disabledFilter[filterId],
          isBoxSelected: selectedFilter.isBox,
          isInventorySelected: selectedFilter.isInventory,
          isSuperSpeedSelected: selectedFilter.isSuperSpeed,
          color: color,
          onForBoxChange: isBox => onChangeBox(filterId, isBox),
          onInventoryChange: isInventory => onInventoryChange(filterId, isInventory),
          onSuperSpeedChange: isSuperSpeed => {
            onSuperSpeedChange(filterId, isSuperSpeed);
          }
        });
      case FilterType.SHIPPING:
        return /*#__PURE__*/React.createElement(ShippingFilterComponent, {
          color: color,
          isInternationalShippingSelected: selectedFilter.isInternationalShipping,
          onInternationalShippingChange: isInternationalShippingSelected => {
            onInternationalShippingChange(filterId, isInternationalShippingSelected);
          }
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(filterData.length) && /*#__PURE__*/React.createElement("div", {
    className: cn(className, classes.container),
    "data-filter": filterName,
    "data-is-attributes": isAttributes
  }, /*#__PURE__*/React.createElement(_Accordion, {
    className: classes.expansionPanel,
    expanded: isItemOpened,
    onChange: handlePanelClick
  }, /*#__PURE__*/React.createElement(_AccordionSummary, {
    className: cn(classes.expansionSummary, {
      [classes.expansionPanelOpened]: isItemOpened
    }),
    IconButtonProps: {
      onClick: isItemOpened ? handleMinimizeIconClick : undefined
    },
    expandIcon: isItemOpened ? /*#__PURE__*/React.createElement(MinimizeIcon, {
      className: classes.expandIcon
    }) : /*#__PURE__*/React.createElement(AddIcon, {
      className: classes.expandIcon
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.expansionPanelContent
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.filterName
  }, lowercaseConjunction(filterName)), type === FilterType.CHECKBOX && /*#__PURE__*/React.createElement("span", {
    className: classes.filterHint
  }, "(Check all that apply)"), /*#__PURE__*/React.createElement(InfoTooltip, {
    filterId: filterId,
    settings: {
      isAvailableSuperSpeed: isAvailableSuperSpeed
    }
  }))), /*#__PURE__*/React.createElement(_AccordionDetails, {
    className: classes.expansionDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filterBody
  }, selectTypeOfFilterItem()), isCollapsible && /*#__PURE__*/React.createElement("button", {
    className: classes.collapseBtn,
    onClick: toggleCollapse
  }, isCollapsed ? 'See All' : 'See Less')))));
};